import { useState } from 'react';

export function useSavedFilters(pageKey) {
  const storageKey = `savedFilters_${pageKey}`;
  const [presets, setPresets] = useState(() => {
    try { return JSON.parse(localStorage.getItem(storageKey) || '[]'); } catch { return []; }
  });
  const save = (name, filters) => {
    const updated = [...presets.filter(p => p.name !== name), { name, filters, savedAt: Date.now() }].slice(-5);
    setPresets(updated);
    localStorage.setItem(storageKey, JSON.stringify(updated));
  };
  const remove = (name) => {
    const updated = presets.filter(p => p.name !== name);
    setPresets(updated);
    localStorage.setItem(storageKey, JSON.stringify(updated));
  };
  return { presets, save, remove };
}
